import { EyeInvisibleOutlined, TableOutlined } from "@ant-design/icons";
import { Button, Checkbox, Popover } from "antd";
import React from "react";

import { type ToggleableColumn } from "~/hooks/useColumnVisibility";

type Props = {
  columns: readonly ToggleableColumn[];
  hiddenColumns: readonly string[];
  onChange: (hiddenColumns: string[]) => void;
};

export const ColumnVisibilityMenu = ({ columns, hiddenColumns, onChange }: Props): React.ReactElement => {
  const hiddenCount = columns.filter(({ key }) => hiddenColumns.includes(key)).length;

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      content={
        <div className="flex min-w-[200px] flex-col gap-2">
          <Checkbox.Group
            className="flex flex-col gap-1"
            value={columns.filter(({ key }) => !hiddenColumns.includes(key)).map(({ key }) => key)}
            options={columns.map(({ key, label }) => ({ value: key, label }))}
            onChange={(visible) => onChange(columns.filter(({ key }) => !visible.includes(key)).map(({ key }) => key))}
          />
          {hiddenCount ? (
            <Button size="small" type="link" className="self-start !px-0" onClick={() => onChange([])}>
              Pokaż wszystkie
            </Button>
          ) : null}
        </div>
      }
    >
      <Button icon={hiddenCount ? <EyeInvisibleOutlined /> : <TableOutlined />}>
        {hiddenCount ? `Kolumny (ukryte: ${hiddenCount})` : "Kolumny"}
      </Button>
    </Popover>
  );
};
